import InvoiceRecurrentService from "@/store/services/invoice.recurrent.service.js"

export default {
  namespaced: true,
  state: {
    summary: null,
    invoiceDate: null, // on create new invoice, this.invoice store is not set yet
    defaultRecurrent: {
      name: '',
      emails: '',
      comments: '',
      start_date: '',
      interval: 'weekly',
      skip: 1,
      end_method: 'endless',
      days: ['0', '1', '2', '3', '4', '5', '6'],
      iterations: null,
      end_date: null
    },
    showModal: false
  },
  getters: {
    getSummary: state => state.summary,
    getDefaultRecurrent: state => state.defaultRecurrent,
    getShowModal: state => state.showModal,
    getInvoiceDate: state => state.invoiceDate
  },
  mutations: {
    SET_SUMMARY (state, summary) {
      state.summary = summary
    },
    SET_INVOICE_DATE (state, date) {
      state.invoiceDate = date
    },
    TOGGLE_MODAL (state) {
      state.showModal = !state.showModal
    },
  },
  actions: {
    saveRecurrent (_, recurrent) {
      return InvoiceRecurrentService.create(recurrent).then((response) => {
        return response.data
      })
    },
    resetSummary ({ commit }) {
      commit('SET_SUMMARY', null)
    },
  }
};
